import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';

const useStyles = makeStyles(createStyles({
  root: {
    height: '475px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  title: {
    color: '#747C99',
    fontSize: '18px',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    paddingBottom: '1em',
  },
  text: {
    color: '#515B6A',
    fontSize: '16px',
  },
}), { name: 'NoData' });

type Props = {
  loading: boolean;
};

const NoData = ({ loading }: Props) => {
  const classes = useStyles();

  return loading ? null : (
    <div className={classes.root}>
      <div className={classes.title}>No Data</div>
      <div className={classes.text}>It looks like there is no data in this category.</div>
    </div>
  );
};

export const noDataPropsMapper = ({ loading }: { loading: boolean }): Partial<Props> => ({ loading });

export default NoData;
